(function () {
  if (window.WTPBConversionReady) return;
  window.WTPBConversionReady = true;
  document.documentElement.dataset.wtpbConversion = 'ready';

  var PAID_LANDING_PATH = '/collections/all-blends';
  var PAID_FORM_HOLD_KEY = 'wtpbPaidFormHoldUntil';
  var PAID_ATTRIBUTION_KEY = 'wtpbPaidAttribution';

  function setupPaidAttribution() {
    var params;
    var isPaidEntry = false;
    var attribution = {};

    try {
      params = new URLSearchParams(window.location.search);
      var source = (params.get('utm_source') || '').toLowerCase();
      var medium = (params.get('utm_medium') || '').toLowerCase();
      isPaidEntry = window.location.pathname === PAID_LANDING_PATH
        && (
          medium === 'paid_social'
          || source === 'facebook'
          || source === 'instagram'
          || source === 'ig'
          || params.has('fbclid')
        );

      if (isPaidEntry) {
        attribution = {
          utm_source: source || (params.has('fbclid') ? 'facebook' : ''),
          utm_medium: medium || 'paid_social',
          utm_campaign: params.get('utm_campaign') || '',
          utm_content: params.get('utm_content') || '',
          utm_term: params.get('utm_term') || '',
          utm_id: params.get('utm_id') || '',
          placement: params.get('placement') || ''
        };
        window.sessionStorage.setItem(PAID_ATTRIBUTION_KEY, JSON.stringify(attribution));
      } else {
        attribution = JSON.parse(window.sessionStorage.getItem(PAID_ATTRIBUTION_KEY) || '{}');
      }
    } catch (error) {}

    document.documentElement.classList.remove('wtpb-paid-form-hold');
    var staleHoldStyle = document.getElementById('wtpb-paid-form-hold-style');
    if (staleHoldStyle) staleHoldStyle.remove();
    try {
      window.sessionStorage.removeItem(PAID_FORM_HOLD_KEY);
    } catch (error) {}

    return {
      isPaidEntry: isPaidEntry,
      attribution: attribution
    };
  }

  var paidContext = setupPaidAttribution();

  // Forward only coarse journey progress. Intake answers and contact details stay out.
  document.addEventListener('wtx:journey', function (event) {
    var detail = event.detail || {};
    if (['new_to_raw', 'experienced_diy', 'already_customer'].indexOf(detail.journey) === -1) return;
    if (['start', 'step_view', 'cart_confirmed', 'failure', 'quote_confirmed'].indexOf(detail.event) === -1) return;
    var payload = { journey: detail.journey };
    if (Number.isInteger(detail.step) && detail.step >= 0 && detail.step <= 5) payload.step = detail.step;
    publish('journey_' + detail.event, payload);
  });

  function cleanPath(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (error) {
      return '';
    }
  }

  function productHandle(url) {
    var path = cleanPath(url);
    var marker = '/products/';
    var index = path.indexOf(marker);

    if (index === -1) return '';
    return path.slice(index + marker.length).split('/')[0];
  }

  function publish(name, data) {
    var payload = Object.assign({}, paidContext.attribution || {}, data || {});

    if ((payload.utm_campaign || '').indexOf('wtxpb_qa_') === 0) {
      document.documentElement.dataset.wtpbLastEvent = name;
    }

    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      try {
        var published = Shopify.analytics.publish('wtpb:' + name, payload);
        if (published && typeof published.catch === 'function') {
          published.catch(function () {});
        }
      } catch (error) {}
    }

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: 'wtpb_' + name }, payload));
    }
  }

  if (paidContext.isPaidEntry) {
    publish('paid_landing_view', {
      destination_path: window.location.pathname,
      device_group: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop'
    });
  }

  document.addEventListener('click', function (event) {
    var tracked = event.target.closest('[data-wtpb-event]');
    if (!tracked) return;

    publish(tracked.dataset.wtpbEvent, {
      placement: tracked.dataset.wtpbPlacement || '',
      cta_id: tracked.dataset.wtpbCta || '',
      destination_path: cleanPath(tracked.href || ''),
      item_handle: tracked.dataset.wtpbItem || '',
      position: tracked.dataset.wtpbPosition || ''
    });
  });

  document.addEventListener('click', function (event) {
    var productLink = event.target.closest('#all-products .product-block a[href*="/products/"], #compare-blends a[href*="/products/"]');
    if (!productLink || productLink.closest('[data-wtpb-event]')) return;

    var comparison = productLink.closest('#compare-blends');
    var productBlock = productLink.closest('.product-block');
    var position = '';

    if (productBlock && productBlock.parentElement) {
      position = String(Array.prototype.indexOf.call(productBlock.parentElement.children, productBlock) + 1);
    }

    publish(comparison ? 'compare_product_click' : 'product_card_click', {
      placement: comparison ? 'all_blends_compare' : 'all_blends_grid',
      destination_path: cleanPath(productLink.href),
      item_handle: productHandle(productLink.href),
      position: position
    });
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('.sls-option, .sls-select, [data-selling-plan-group-option-radio], [data-one-time-option-radio]')) return;

    var type = event.target.dataset.type || '';
    var label = event.target.options && event.target.selectedIndex > -1
      ? event.target.options[event.target.selectedIndex].textContent.trim()
      : event.target.value || '';

    publish('subscription_select', {
      purchase_option: type || label,
      item_handle: document.body.dataset.productHandle || ''
    });
  });

  document.addEventListener('click', function (event) {
    var addButton = event.target.closest('[data-add-to-cart]');
    if (!addButton) return;

    publish('atc_click', {
      atc_location: addButton.dataset.wtpbAtcLocation || 'product_form',
      item_handle: document.body.dataset.productHandle || ''
    });

    delete addButton.dataset.wtpbAtcLocation;
  });
}());

